export default __webpack_public_path__ + "static/media/bag.44b4954c.svg";